
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embed/[[...all]]",
      function () {
        return require("private-next-pages/embed/[[...all]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embed/[[...all]]"])
      });
    }
  